export function URLjoin(parts: Array<string>, appendSlash:boolean = true, joiner:string="/"): string{
    let output:string = "";
    for(let part of parts){
        if(!output){
            output = part;
            continue;
        }
        while(output.endsWith(joiner)){
            output = output.substring(0, output.length-1);
        }
        while(part.startsWith(joiner)){
            part = part.substring(1);
        }
        output = output + joiner + part;
    }
    if(appendSlash && !output.endsWith(joiner)){
        output += joiner;
    }
    return output;
}

export function URLQuery(root:string, queryParams:Record<string, string>){
    return root + "?" +
    Object.entries(queryParams)
        .map(([key, value]) => (`${ encodeURI(key)}=${encodeURI(value)}`))
        .join("&");
}